/**
 * 0.45.89 - Reading a value by name, where the name may reach into an
 * object value (a variable holding a whole row): `sign.nature.type.en`.
 */
import { readPath } from './apiResponsePath';

/** A value by name, or by name.path into an object value.
 *
 * The name itself is tried first, so a stored key with a dot (a flow
 * step's instance prefix, "home.postcode") is found as before. */
export function readValue(values, name) {
  if (!values || name == null) return undefined;
  const key = String(name);
  if (Object.prototype.hasOwnProperty.call(values, key)) return values[key];
  if (!key.includes('.')) return undefined;
  const parts = key.split('.');
  for (let i = parts.length - 1; i >= 1; i -= 1) {
    const base = parts.slice(0, i).join('.');
    const v = values[base];
    if (v && typeof v === 'object') {
      const got = readPath(v, parts.slice(i).join('.'));
      return got === null ? undefined : got;
    }
  }
  return undefined;
}


/* 0.46.16 - A value as display text. A list (from `[]` in a path) is
 * its items joined by ", ", with empty items left out and lists in
 * lists flattened. An object is not text: it shows nothing, as a
 * missing value does, rather than "[object Object]". */
export function listText(v) {
  if (v === null || v === undefined) return '';
  if (Array.isArray(v)) {
    return v.flat(Infinity)
      .filter(x => x !== null && x !== undefined && x !== '' && typeof x !== 'object')
      .map(String).join(', ');
  }
  if (typeof v === 'object') return '';
  return String(v);
}
